<template>
	<div class="badge" :style="style">
		{{status.name}}
	</div>
</template>

<script>
export default {
	props: ['status'],
	computed: {
		style () {
			return `background-color:${this.status.color}; color: white;`;
		}
	}
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ui/StatusBadge.vue